import produce from "immer";
import React, { FC, useRef } from "react";
import { useDrag, useDrop } from "react-dnd";
import { useDispatch, useSelector } from "react-redux";
import { startEditProtoType } from "../../../actions/protoTypeAction";
import { Form } from "../../../models/formModel";
import { getPrototype } from "../../../selectors/protoTypeSelector";
import { ItemTypes } from "../../../utils/itemTypes";
import { BsArrowDownLeft, BsArrowDownRight, BsArrowRight, BsArrowLeft, BsArrow90DegDown } from "react-icons/bs"

export interface FormRowComponentProps {
  form: Form;
  index: number;
  isLast?: boolean;
  isReverse : boolean;
  formListLength : number;
}

const FormDisplayComponent: FC<FormRowComponentProps> = ({
  form,
  index,
  isLast = false,
  isReverse,
  formListLength,
}) => {
  // console.log(formListLength)
  const dispatch = useDispatch();
  const prototypeState = useSelector(getPrototype);
  const ref = useRef<HTMLDivElement>(null);
  const [, drag] = useDrag({
    type: ItemTypes.FORM_MOVE,
    item: { dragItem: form, index: index },
  });

  const [{ isOver, isOverCurrent }, drop] = useDrop({
    accept: [ItemTypes.FORM_DRAG, ItemTypes.FORM_MOVE],
    drop(item: Form, monitor) {
      const dropType = monitor.getItemType();
      const didDrop = monitor.didDrop();
      if (dropType !== ItemTypes.FORM_DRAG || didDrop) {
        return;
      }
      console.log(item);
      const newProtoTypeState = produce(prototypeState, (draft) => {
        draft.formList.splice(index + 1, 0, item);
      });
      dispatch(startEditProtoType(newProtoTypeState));
    },
    hover(item: any, monitor) {
      const hoverType = monitor.getItemType();
      if (hoverType === ItemTypes.FORM_MOVE) {
        const dragIndex = item.index;
        const hoverIndex = index;

        if (dragIndex === hoverIndex) return;
        const newProtoTypeState = produce(prototypeState, (draft) => {
          draft.formList.splice(dragIndex, 1);
          draft.formList.splice(hoverIndex, 0, item.dragItem);
        });
        dispatch(startEditProtoType(newProtoTypeState));
        item.index = hoverIndex;
      }
    },
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      isOverCurrent: monitor.isOver({ shallow: true }),
    }),
  });

  // drop(drag(ref));

  return (
    <>
    { 
    (form.id === "Start" || form.id === "End") ? 
    (  <div className="col-1 prototype-start-end" key={`${form.id}`}>
        {form.name}
      </div>) :
    (
      <div ref={drag} className="col-1 prototype-card" key={`${form.id}`}>
        {form.name}
      </div>
    )
  }

      {(!isLast && !isReverse && form.id !== "End") && (
        (formListLength > 2) ? (
          (form.id !== "Start") ? (
            <div
            ref={drop}
            className="col-1 prototype-card-arrow"
            key={`${form.id}-arrow`}
          >
            <span className="drop-position">Drop Here</span>
            <BsArrowRight size={80}/>
          </div>
          ):(
            <div
            className="col-1 prototype-card-arrow"
            key={`${form.id}-arrow`}
          >
            <div className="mt-3 emptyBox"></div>
            <BsArrowRight size={80}/>
          </div>
          )
        ):(
          <div
          ref={drop}
          className="col-1 prototype-card-arrow"
          key={`${form.id}-arrow`}
        >
          <span className="drop-position">Drop Here</span>
          <BsArrowRight size={80}/>
        </div>
        )

      )}
      {(!isLast && isReverse && form.id !== "End") && (
        <div
          ref={drop}
          className="col-1 prototype-card-arrow"
          key={`${form.id}-arrow`}
        >
          <span className="drop-position">Drop Here</span>
          <BsArrowLeft size={80}/>
        </div>
      )}
      {( isLast && !isReverse && form.id !== "End") && (
        <div
          ref={drop}
          className="col-1 prototype-card-arrow-down"
          key={`${form.id}-arrow`}
        >
          <span className="drop-position">Drop Here</span>
          <BsArrow90DegDown className=" flip-arrow" size={80}/></div>
      )}
      {( isLast && isReverse && form.id !== "End") && (
        <div
          ref={drop}
          className="col-1 prototype-card-arrow-down-reverse"
          key={`${form.id}-arrow`}
        >
          <span className="drop-position">Drop Here</span>
          <BsArrow90DegDown size={80}/></div>
      )}
    </>
  );
};

export default FormDisplayComponent;
